import { Fragment, useContext, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { isValidArray } from "./common";
import { GlobalContext } from "../../Context/GlobalContext";
import { categoryById, categoryByUrl } from "../../utils/categoryIndex";

export const HybridBreadCrumb = ({ data, familyDetails, leading }) => {
  const [breadcrumbList, setBreadcrumbList] = useState(null);
  const { categoryDataAll, categoryIndex } = useContext(GlobalContext);
  const location = useLocation();
  useEffect(() => {
    let previousCateogry = location.state?.fromUrlPath;
    const previousCategory = getParentCategories(previousCateogry);
    var currentPage = getCurrentPageBreadCrumbs();
    if (isValidArray(previousCategory)) {
      setBreadcrumbList([...previousCategory, ...(isValidArray(currentPage) ? currentPage : [])]);
    } else {
      if (isValidArray(data)) {
        currentPage = getCurrentPageBreadCrumbs();
        setBreadcrumbList([...data, ...(isValidArray(currentPage) ? currentPage : [])]);
        if (categoryDataAll) {
          var minimizedCategory = categoryDataAll.filter((i) =>
            normalizePath(i.eaPath).includes(normalizePath(data[0]["name"])),
          );
          const breadcrumbNames = data.map((item) => item.name);
          const breadcrumbItems = breadcrumbNames
            .map((item, index) => {
              const partialPath = breadcrumbNames.slice(0, index + 1).join(" > ");
              const cat = minimizedCategory.find((cat) => normalizePath(cat.eaPath) == normalizePath(partialPath));
              return { name: item, url: cat?.url ?? "" };
            })
            .filter(Boolean);

          setBreadcrumbList([...breadcrumbItems, ...(isValidArray(currentPage) ? currentPage : [])]);
        }
      } else {
        setBreadcrumbList(null);
      }
    }
  }, [data, categoryDataAll, familyDetails]);

  const getParentCategories = (previousCategory) => {
    if (!previousCategory || !isValidArray(categoryDataAll)) return [];

    const target = normalizeUrl(previousCategory);
    if (!target) return [];

    let current = categoryByUrl(categoryIndex, target);
    if (!current) return [];

    const matchedCategories = [];
    const visited = new Set();

    while (current && !visited.has(String(current.categoryId))) {
      visited.add(String(current.categoryId));
      matchedCategories.unshift({ name: current.categoryName, url: current.url });

      const parentId = String(current.parentCategory);
      if (parentId == "0" || !parentId) break;
      current = categoryById(categoryIndex, parentId);
    }

    return matchedCategories;
  };

  const getCurrentPageBreadCrumbs = () => {
    const familyUrl = window.location.pathname;
    if (window.location.search.includes("sku=")) {
      return [
        {
          name: familyDetails.familyName,
          url: familyUrl,
        },
        {
          name: String(familyDetails.sku).toUpperCase(),
          url: familyUrl + window.location.search,
        },
      ];
    } else
      return [
        {
          name: String(familyDetails.familyName).toUpperCase(),
          url: familyUrl,
        },
      ];
  };

  const normalizePath = (path = "") => String(path).toLowerCase().replace(/\s+/g, " ").trim();
  const normalizeUrl = (url = "") => normalizePath(url).replace(/^\/+|\/+$/g, "");
  const breadcrumbNav = isValidArray(breadcrumbList) && (
    <nav aria-label="breadcrumb">
      <ol className="breadcrumb">
        <li className="breadcrumb-item">
          <Link to={"/"}>Home</Link>
        </li>
        {breadcrumbList.map((pill, index) => (
          <li key={index} className={`breadcrumb-item ${index == breadcrumbList.length - 1 ? "active" : ""}`}>
            <Link
              to={pill.url}
              dangerouslySetInnerHTML={{
                __html: pill.name,
              }}
            ></Link>
          </li>
        ))}
      </ol>
    </nav>
  );

  return (
    <Fragment>
      {(isValidArray(breadcrumbList) || leading) && (
        <section className="breadcrumb-section">
          <div className="container-fluid container-lg">
            <div className="row">
              <div className="col-lg-12">
                {leading ? (
                  <div className="breadcrumb-with-back">
                    {leading}
                    {breadcrumbNav}
                  </div>
                ) : (
                  breadcrumbNav
                )}
              </div>
            </div>
          </div>
        </section>
      )}
    </Fragment>
  );
};
